import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { PROFILE_SECTION_IDS } from '../../lib/constants';
import { RatingsAndReviewsHeader } from './styles';
import { showReviewSection } from '../../lib/utils';

interface RatingsAndReviewsSummaryProps {
  shouldHidePageAnchors: boolean;
  provider: ProviderMatchProviderV9;
  ratingReviewCountHref: string;
  handleClickRatingReviewCount?: (e: React.MouseEvent) => void;
}
export const ProviderRatingsAndReviewsSummary = withErrorBoundary(
  ({
    shouldHidePageAnchors,
    provider,
    handleClickRatingReviewCount
  }: RatingsAndReviewsSummaryProps) => {
    if (!showReviewSection(provider)) {
      return null;
    }
    return (
      <RatingsAndReviewsHeader
        data-testid="ratings-and-reviews-header"
        providerReviews={provider.reviews}
        shouldHidePageAnchors={shouldHidePageAnchors}
        ratingReviewCountHref={`#${PROFILE_SECTION_IDS.REVIEWS}`}
        handleClickRatingReviewCount={handleClickRatingReviewCount}
      />
    );
  }
);
